import { View, Text, StyleSheet } from "react-native";
import { TodoCard, TodoItem } from "../../interfaceComponents/todoCard/TodoCard";

interface TodoEntry extends TodoItem {
  id: string;
  workspacesHasTodo?: Array<{ id: string; name: string }>;
}

interface TodoCardListProps {
  categoryName?: string;
  todos: TodoEntry[];
  toggleCompletion: (id: string, value: boolean) => void;
  discussTask?: (id: string) => void;
}

export const TodoCardList = ({ categoryName, todos, toggleCompletion, discussTask }: TodoCardListProps) => {
  return (
    <View style={styles.container}>
      {!!categoryName && <Text style={styles.titleText}>{categoryName}</Text>}
      {todos.map((todo) => (
        <TodoCard
          key={todo.id}
          {...todo}
          workspaceName={todo.workspacesHasTodo?.[0]?.name}
          toggleCompletion={(value: boolean) => {
            toggleCompletion(todo.id, value);
          }}
          discussTask={
            discussTask != null
              ? () => {
                  discussTask(todo.id);
                }
              : undefined
          }
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 16,
  },
  titleText: {
    color: "#101828",
    fontSize: 14,
    fontWeight: 600,
  },
});
